<template>
  <div>
    <section class="home-base-list-sec mob-sec">
      <div class="home-base-list__inner pis-container">
        <div v-if="base_list">
          <div
            class="row no-gutters justify-content-center"
            v-for="(base_row, index) in base_list_static"
            v-bind:key="index"
          >
            <div v-for="base in base_row" v-bind:key="base.id" class="col-6">
              <!--                         :class="{'open':openSubBase === base.extCode}"-->
              <div
                class="home-base-mob"
                :class="{ open: openSubBase === base.extCode }"
              >
                <div
                  :class="'home-base__card  text-center base_' + base.extCode"
                >
                  <div class="home-base__card-inner ">
                    <div class="home-base__card-icon ">
                      <span
                        :class="
                          base.class +
                            '_color ' +
                            'icon-pis-color icon-' +
                            base.extCode
                        "
                      ></span>
                    </div>
                    <div class="home-base__card-header">
                      <h3 class="home-base__card-title">
                        <a
                          v-if="base.extCode === 'LIE'"
                          v-html="base.name"
                          :href="base.link"
                          target="_blank"
                        >
                        </a>
                        <router-link v-else v-html="base.name" :to="base.link">
                        </router-link>
                      </h3>
                    </div>
                    <div class="home-base__card-bottom">
                      <div class="home-base__card-link-sec">
                        <a
                          v-if="base.extCode === 'LIE'"
                          :class="{
                            'home-base__card-link  ': true,
                            'animated-icon': base.children,
                          }"
                          :href="base.link"
                          target="_blank"
                        >
                          <span class="icon-chevron-right "></span>
                        </a>
                        <template v-else>
                          <a
                            v-if="base.children"
                            @click.stop.prevent="openSubBaseFunc(base.extCode)"
                            :class="{
                              'home-base__card-link  ': true,
                              'animated-icon': base.children,
                            }"
                            href="#"
                          >
                            <span class="icon-chevron-right "></span>
                          </a>
                          <router-link
                            v-else
                            :to="base.link"
                            :class="{
                              'home-base__card-link  ': true,
                              'animated-icon': base.children,
                            }"
                          >
                            <span class="icon-chevron-right "></span>
                          </router-link>
                        </template>
                      </div>
                    </div>
                    <div class="home-base__card-footer "></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="home-base__card-menu-2 col-12"
              v-for="base in base_row"
              v-bind:key="base.id + 22"
              :class="'base_' + base.extCode"
            >
              <!--                                :class="{openSubBase === base.extCode:'open'}"-->
              <div class="mob-base-menu" v-if="openSubBase === base.extCode">
                <ul v-if="base.children" class="home-base__card-nav ">
                  <li
                    class="home-base__card-nav-item nav-item"
                    v-for="child in base.children"
                    v-bind:key="child.id"
                  >
                    <router-link
                      v-html="child.name"
                      class="nav-link"
                      :to="'/' + child.link"
                    >
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomeBaseListMobSec",
  data() {
    return {
      openSubBase: false,
      base_list: [],
      base_list_static: [
        [
          {
            extCode: "TGGROUP",
            id: 1000,
            name: "Службени гласник Републике Србије",
            icon: "book",
            class: "pis_slglrs",
            link: "#",
            children: [
              {
                id: 1001,
                name: "Службени гласник РС",
                link: "slglrsNP-overview/all",
              },
              {
                id: 1002,
                name: "Службени гласник РС - Међународни уговори",
                link: "slglrsMUTG-overview/all",
              },
              {
                id: 1003,
                name: "Службени гласник РС - Просветни гласник",
                link: "slglrsPG2010-overview/all",
              },
            ],
          },
          {
            extCode: "ARHGROUP",
            id: 2000,
            name: "Архива службених гласила",
            icon: "inbox",
            class: "pis_arhslgl",
            link: "#",
            children: [
              {
                id: 2001,
                name: "Архива Службеног гласника",
                link: "arhslgl-sgarh",
              },
              {
                id: 2002,
                name: "Архива Просветног гласника",
                link: "arhslgl-pgarh",
              },
              {
                id: 2003,
                name: "Архива Службеног листа",
                link: "arhslgl-slarh",
              },
              {
                id: 2004,
                name:
                  "Архива ратификованих међународних уговора и других аката",
                link: "arhslgl-muarh",
              },
            ],
          },
        ],
        [
          {
            extCode: "REG",
            id: 3000,
            name:
              "\u0420\u0435\u0433\u0438\u0441\u0442\u0430\u0440 \u0438 \u0442\u0435\u043a\u0441\u0442\u043e\u0432\u0438 \u0432\u0430\u0436\u0435\u045b\u0438\u0445 \u043f\u0440\u043e\u043f\u0438\u0441\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0430\u043a\u0430\u0442\u0430",
            icon: "law",
            class: "pis_reg",
            link: "/reg-overview",
            children: null,
          },
          {
            extCode: "SP",
            id: 4000,
            name:
              "\u0421\u0443\u0434\u0441\u043a\u0430 \u043f\u0440\u0430\u043a\u0441\u0430",
            icon: "auction",
            class: "pis_supa",
            link: "supa-standardSearch",
            children: null,
          },
        ],
        [
          {
            extCode: "LIE",
            id: 50000,
            name:
              "\u041f\u0440\u043e\u043f\u0438\u0441\u0438 \u043d\u0430 \u0435\u043d\u0433\u043b\u0435\u0441\u043a\u043e\u043c \u0458\u0435\u0437\u0438\u043a\u0443",
            icon: "law-en",
            class: "pis_laen",
            link: window.env.VUE_APP_EN_BASE_URL_PRODUCTION,
            children: null,
          },
          {
            extCode: "LSD",
            id: 6000,
            name:
              "\u041c\u0438\u0448\u0459\u0435\u045a\u0430, \u043c\u043e\u0434\u0435\u043b\u0438, \u043b\u0438\u0442\u0435\u0440\u0430\u0442\u0443\u0440\u0430",
            icon: "open-book",
            class: "pis_mml",
            link: "mml-standard-search",
            children: null,
          },
        ],

        [
          {
            extCode: "WPPGROUP",
            id: 7000,
            name: "Посебни програмски пакети",
            icon: "box",
            class: "pis_ppp",
            link: "#",
            children: [
              {
                name: "Водич кроз пресуде Европског суда за људска права",
                link: "pp-content/WPP_ESZLJP_GUIDE",
              },
              {
                name: "Кривична дела у судској пракси",
                link: "pp-content/WPP_KD",
              },
              {
                name: "Прописи града Београда",
                link: "/regulations-overview",
              },
            ],
          },
        ],
      ],
      baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,
    };
  },
  methods: {
    openSubBaseFunc(code) {
      if (!this.openSubBase) {
        this.openSubBase = code;
      } else if (this.openSubBase === code) {
        this.openSubBase = null;
      } else {
        this.openSubBase = code;
      }
      //dsdsdsd
    },
  },
};
</script>

<style scoped></style>
